export class JordanRequestedInfo {    
    jordanNationalNumber: string = '';

    constructor(jsonObject: any = null) {
        if (jsonObject !== null) {
            if (jsonObject instanceof JordanRequestedInfo) {               
                this.jordanNationalNumber = jsonObject.jordanNationalNumber;
            }  else {
                // this is a json object let's deserialize it
                if (jsonObject.hasOwnProperty('attributes') && jsonObject.attributes instanceof Array) {
                    jsonObject.attributes.forEach( (property : any) => {
                        if (property.name === "JORDAN NATIONAL NUMBER") {
                            this.jordanNationalNumber = property.value;
                        }
                    });
                }              
            }
        }
    }
}
